module.exports = __webpack_public_path__ + "img/set.bf458b20.png";